var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-notification",class:{ 'top-notification-open': _vm.notification },domProps:{"innerHTML":_vm._s(_vm.notification)}})}
var staticRenderFns = []

export { render, staticRenderFns }